import { CommonModule } from '@angular/common';
import { Component, Input } from '@angular/core';
import { PipesModule } from '@app/pipes';

@Component({
  selector: 'mnf-pi-v2-info-metrics',
  standalone: true,
  imports: [CommonModule, PipesModule],
  templateUrl: './pi-v2-info-metrics.component.html',
  styleUrl: './pi-v2-info-metrics.component.scss'
})
export class PiV2InfoMetricsComponent {

  @Input() metrics: string[];
  @Input() metricsDescription: string;

  contenedores = [
    { title: 'Financiamiento sobre el valor', subtitle: '50.00%' },
    { title: 'Garantia', subtitle: 'Hipotecaria' },
    { title: 'Garantia sobre financiamiento ', subtitle: '2 a 1' },
    { title: 'Control de flujos de financiamiento', subtitle: 'Por etapas' }
  ]
}
